module.exports = __webpack_public_path__ + "static/media/rove_logo.bcc47de5.png";